export const closeButton = {
  position: 'absolute',
  top: 8,
  right: 8,
  padding: 0,
  zIndex: 10,
};

export const headerBox = {
  display: 'flex',
  alignItems: 'center',
  gap: { xs: 0, sm: 0.5 },
  mb: { xs: 0.5, sm: 2 },
  pt: 0,
  width: { xs: '90%', sm: '100%' },
};

export const thickCloseIcon = theme => ({
  color: theme.red,
  fontSize: { xs: '22px', sm: '26px' },
  flexShrink: 0,
});

export const titleText = {
  fontWeight: 700,
  color: '#000',
  fontSize: { xs: '16px', sm: '20px', md: '24px' },
  lineHeight: 1.2,
  overflowWrap: 'break-word',
  flex: 1,
  minWidth: 0,
  flexShrink: 1,
};

export const mainText = {
  fontSize: { xs: '14px', sm: '18px', md: '19px' },
  color: '#000',
};

export const subTextStyle = {
  fontSize: { xs: '14px', sm: '15px', md: '16px' },
  color: '#555',
};

export const closeActionButton = theme => ({
  fontWeight: 600,
  px: 4,
  py: 1,
  lineHeight: { xs: 1, sm: 1.75 },
  fontSize: 16,
  borderRadius: 1,
  mt: { xs: 1 },
  '&:hover': {
    backgroundColor: theme.primary,
    color: theme.text1,
  },
});
